import * as React from 'react';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';

import MotorFunctionHistory from './HistoryRowData/MotorFunction';
import MobilityAidHistory from './HistoryRowData/Aid';
import Form from './Form';
import { filterByDocumentType } from 'Utility/documentHandling';

const docType = (
  documents: Array<IDocumentWithTypeV2<'motorfunction' | 'mobilityAid'>>,
  editing: string,
  view?: IView,
): SafeExtract<TDocumentType, 'motorfunction' | 'mobilityAid'> | undefined =>
  editing
    ? documents.find(d => d._id === editing)?._type
    : view?.viewing
      ? documents.find(d => d._id === view.viewing)?._type
      : undefined;

const MotorFunction = ({ documents }: IOwnProps): React.JSX.Element => {
  const motorfunctionDocs = filterByDocumentType(documents, 'motorfunction');
  const mobilityAidDocs = filterByDocumentType(documents, 'mobilityAid');

  return (
    <FormEditingHandler name="motorFunctionAndMobilityAid" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="motorFunctionAndMobilityAid"
            headerId={
              {
                motorfunction: 'motorFunctionAndMobilityAid.motorfunction.title',
                mobilityAid: 'motorFunctionAndMobilityAid.aids.title',
                '': undefined,
              }[docType(documents, editing, view) ?? ''] || 'motorFunctionAndMobilityAid.title'
            }
            editing={editing}
            editButtons={<div />}
          />

          {editing ? <Form formData={formData} document={documents.find(d => d._id === editing)} /> : null}

          {!editing ? (
            <>
              <MotorFunctionHistory documents={motorfunctionDocs} startEdit={startEdit} />
              <MobilityAidHistory documents={mobilityAidDocs} startEdit={startEdit} />
            </>
          ) : null}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'motorfunction' | 'mobilityAid'>>;
}

export default MotorFunction;
